
import { Dialog, DialogContent, IconButton, makeStyles, Slide, Typography } from "@material-ui/core"
import React from "react"
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from '@material-ui/icons/Close';
import { CreateNewResponse } from "./CreateQuestion/formCreateResponse";
import { EditResponse } from "./EditQuestion/formEditResponse";
import theme from "../../../app/config/themaConfig";


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

//My style
const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    root: {
        margin: 0,
        padding: theme.spacing(2)
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500]
    },

}));

const DialogTitle = ((props) => {
    const classes = useStyles();
    const { children, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6" style={{ textAlign: "center" }}>{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

export default function ModalResponse({ setopenMondal, isOpen, dataEdit, setdataEdit, isEdit, createResponse, editResponse,ID,idQuestion}) {

    const clearData = () => {
        setopenMondal(false)
        setdataEdit({})
    }
    const primaryColor = theme.palette.primary.main;

    return (
        <div>
            <Dialog
                onClose={(e) => { clearData() }}
                aria-labelledby="customized-dialog-title"
                open={isOpen}
                TransitionComponent={Transition}
                keepMounted
                style={{ maxHeight: "500%" }}
                fullWidth={true}
                maxWidth="xs"
            >
                <DialogTitle id="customized-dialog-title" onClose={(e) => { clearData() }} style={{color:primaryColor}} >
                    {isEdit? "Editar Respuesta": "Crear Respuesta"}
                </DialogTitle>
                <DialogContent style={{ paddingBottom: '30px' }}>
                    {isEdit ?
                        (
                            <EditResponse dataEdit={dataEdit} editResponse={editResponse}idQuestion={idQuestion}/>
                        )
                        :
                        (
                            <CreateNewResponse createResponse={createResponse} ID={ID} />
                        )

                    }

                </DialogContent>
            </Dialog>
        </div>
    )
}